import { useAppSelector } from "@/store/hooks";
import { Category } from "@/store/slices/storeSlice";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";

const BASE_ROUTE: Category = {
  term_id: 0,
  name: "",
  slug: "/",
  term_group: 0,
  term_taxonomy_id: 0,
  taxonomy: "product_cat",
  description: "",
  parent: 0,
  count: 0,
  filter: "raw",
  order: "0",
};

const useDynamicCategoriesRouter = () => {
  const params = useParams();
  const location = useLocation();
  const [currentCat, setCurrentCat] = useState(BASE_ROUTE);
  const [parts, setParts] = useState([""]);
  const [childCats, setChildCats] = useState([]);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isLesson, setIsLesson] = useState(false);
  const [isLessonListing, setIsLessonListing] = useState(false);
  const portal = useAppSelector((state) => state.store.portal);

  useEffect(() => {
    const pathname = params["*"];
    const segments = pathname?.split("/");

    if (segments) {
      setParts(segments);
      let currentCat = portal?.cats?.find(
        (cat) =>
          decodeURIComponent(cat.slug) === segments?.[segments?.length - 1]
      );

      let isThisALesson = !!portal?.data?.find(
        (lesson) =>
          decodeURIComponent(lesson.post_name) ===
          decodeURIComponent(segments?.[segments?.length - 1])
      );

      setCurrentCat(currentCat);

      setChildCats(
        portal?.cats?.filter((cat) => cat.parent === currentCat?.term_id)
      );

      setIsNotFound(
        !portal?.cats?.find(
          (cat) =>
            decodeURIComponent(cat.slug) ===
            decodeURIComponent(segments?.[segments?.length - 1])
        ) && !isThisALesson
      );

      setIsLessonListing(
        !portal?.cats?.find((cat) => cat.parent === currentCat?.term_id)
      );

      setIsLesson(isThisALesson);
    } else {
      setParts([""]);
      setCurrentCat(BASE_ROUTE);
      setChildCats(
        portal?.cats?.filter((cat) => cat.parent === BASE_ROUTE?.term_id)
      );
      setIsLessonListing(false);
      setIsNotFound(false);
      setIsLesson(false);
    }
  }, [params, portal, location]);

  return {
    currentCat,
    parts,
    childCats,
    isNotFound,
    isLessonListing,
    isLesson,
  };
};

export default useDynamicCategoriesRouter;
